import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";

const TitleContentImage = ({title, richContent, image}) => {
    return (
        <section className='title-content-image'>
            <div className='title-content-image__inner'>
                <div className='title-content-image__title' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                    {title && <h2>{parse(title)}</h2>}
                    {richContent && <StructuredText data={richContent}/>}
                </div>

                <div className='title-content-image__image' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                    {image && <Asset asset={image}/>}
                </div>
            </div>
        </section>
    )
}

export default TitleContentImage

export const query = graphql`
fragment TitleContentImageProps on DatoCmsTitleContentImage {
  ... on DatoCmsTitleContentImage {
    id
    title
    richContent {
      value
    }
    image {
      ...InternalAssetProps
    }
  }
}
`